import React, { useEffect, useState } from "react";
import { FaCheckCircle, FaChevronCircleDown, FaChevronCircleUp, FaChevronDown, FaChevronUp, FaInfoCircle } from "react-icons/fa";
import { useParams } from "react-router-dom"
import { useModal } from "../../../../hooks/Modal";
import { useToast } from "../../../../hooks/Toast";
import api from "../../../../services/api";
import { ProductContainerInfo } from "./styles";

interface IProps {
    product_id?: string;
}

const ExtraProducts: React.FC<IProps> = ({ product_id = '' }) => {

    const { projectHash } = useParams<Record<string, any>>();
    const { addToast } = useToast();
    const { addModal, removeModal } = useModal();
    const [products, setProducts] = useState<Array<Record<string, any>>>([]);
    const [tickets, setTickets] = useState<Array<Record<string, any>>>([]);
    const [loading, setLoading] = useState(false);
    const [currentValue, setCurrentValue] = useState('');

    const [loadInfos, setLoadInfos] = useState<Array<Record<string, any>>>([]);

    const load = async () => {
        setLoading(true);

        setTimeout(async () => {
            const productsList = await api.get(`/list-extra-product/${projectHash}`);
            const myTickets = await api.get(`/my-tickets/${projectHash}`);

            if (productsList?.data?.rows) {
                productsList?.data?.rows.sort((a, b) => a.position > b.position ? 1 : a.position < b.position ? -1 : 0)
            }

            setTickets(myTickets?.data?.rows || []);
            setProducts(productsList?.data?.rows || []);

            setLoading(false);
        }, 3000)






    }


    const addProduct = async (id: string) => {



        try {

            const response = await api.post(`/add-extra-product/${id}`);



            return '';



        }
        catch (err) {

            return err?.response?.data?.message || err?.response?.data?.error || 'Erro ao se inscrever';
        }

    }

    const addToAll = (product) => {

        setLoadInfos((state) => {

            const index = state.findIndex(s => s._id?.toString() === product?._id?.toString());
            let filtered: Array<Record<string, any>> = [];
            if (index >= 0) {
                filtered = state?.filter(s1 => s1._id?.toString() !== product?._id?.toString()) || [];



            }
            else {
                if (product?.restriction_group) {
                    filtered = state?.filter(s2 => (s2.restriction_group !== product?.restriction_group));
                }

                filtered.push(product);
            }

            return filtered;

        })

    }

    const addToGlobal = async (productsGlobal) => {

        setLoading(true);


        if (productsGlobal.length >= 0) {
            if (productsGlobal) {
                productsGlobal.sort((a, b) => a.position > b.position ? 1 : a.position < b.position ? -1 : 0)
            }

            let x = 0;
            const length = productsGlobal.length;

            let content = '';

            while (x < length) {


                const product = productsGlobal[x];
                const value = await addProduct(product?._id?.toString());

                if (value) {
                    content = `${content}<p style="color: #333">${value}</p><br/>`
                }


                x = x + 1;
            }

            if (content) {

                addModal({ title: '', content: <p dangerouslySetInnerHTML={{ __html: content }} />, theme: 'whiteModal2' })
                await load();
                setLoading(false);
            }
            else {
                addToast({ title: 'Inscrições realizadas com sucesso', type: 'success' });

                await load();
                setLoading(false);
            }

        }
        else {
            addToast({ title: 'Selecione ao menos uma inscrição', type: 'info' });
            setLoading(false);
        }


    }

    const addOnLoad = async (id) => {
        const response = await addProduct(id);
        if (response) {
            addToast({ title: 'Erro ao realizar inscrição na atividade', type: 'error' });
        }
        else {
            load();
        }
    }

    useEffect(() => {

        if (product_id) {
            addOnLoad(product_id);
        }


    }, [product_id]);

    const modalAdd = (product) => {


        addModal({
            title: '', key: 'modal-product', theme: 'whiteModal2', content: <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '15px' }}>
                <h2 style={{ color: '#333', width: '100%' }}>Confirmar inscrição</h2>
                <p style={{ color: '#333', width: '100%' }}>{product?.title}</p>

                <button className="defaultButton" style={{ background: 'rgb(0,15,64)', color: '#fff' }} onClick={() => addProduct(product._id?.toString())}>Confirmar</button>
            </div>
        })

    }

    useEffect(() => {

        if (projectHash) {
            load();
        }

    }, [projectHash])




    return <div style={{
        width: '100%', minHeight: '200px', position: 'relative'
    }}>

        {loading && <div style={{
            position: 'absolute', background: '#eee', padding: '15px', top: '0px', left: '0px', width: '100 % ', bottom: '0px', right: '0px', display: 'flex', justifyContent: 'center', alignItems: 'center'
        }}>
            <h2 style={{ color: '#333' }
            } > Carregando atividades adicionais...</h2>
        </div >
        }
        {
            products?.length > 0 ? <ProductContainerInfo>

                <h2 style={{ color: '#333', textAlign: 'center', width: '100%' }}>Selecione as atividades que deseja participar</h2>
                <p style={{ color: '#333', marginBottom: '15px', textAlign: 'center', width: '100%' }}>*Atenção, caso você escolha uma atividade no mesmo horário, a anterior será cancelada automaticamente.</p>

                <table><tbody>



                    {products.map(product => {

                        const index = tickets.findIndex(ticket => ticket.product_id === product._id);
                        const indexOf = tickets.findIndex(ticket => product.restriction_group && ticket.product_id_response?.restriction_group === product.restriction_group);

                        return <tr key={`extra_product_${product._id}`}>

                            <td style={{ width: '30px' }}>
                                {index < 0 && indexOf >= 0 ? <FaInfoCircle title="Você já está inscrito em outra atividade no mesmo horário" style={{ width: '25px', height: '25px', color: 'blue' }} /> : index >= 0 ? <FaCheckCircle title="Inscrição confirmada" style={{ width: '25px', height: '25px', color: 'green' }} /> : product?.available_quantities <= 0 ? <FaInfoCircle title="Vagas esgotadas" style={{ width: '25px', height: '25px', color: 'red' }} /> : <input checked={loadInfos?.findIndex(f => f?._id?.toString() === product?._id?.toString()) >= 0} style={{ width: '20px', height: '20px' }} type="checkbox" name="text" onClick={() => { addToAll(product) }} />}
                            </td>

                            <td>
                                <strong style={{ width: 'auto', padding: '10px', color: '#333' }}>{product.date_time}</strong>
                                <h2 style={{ color: 'rgb(0, 0, 127)', padding: '10px', }}>{product.title}</h2>


                                {product?.description && currentValue === product?._id?.toString() ? <p style={{ color: '#333', padding: '10px', }} dangerouslySetInnerHTML={{ __html: product?.description }} /> : <></>}


                            </td>
                            <td style={{ maxWidth: '30px', display: 'flex', alignItems: 'center', gap: '5px' }}>

                                {currentValue !== product?._id?.toString() ? <FaChevronCircleDown style={{ minHeight: '25px', color: '#333', minWidth: '25px', cursor: 'pointer' }} onClick={() => setCurrentValue(state => state === product?._id?.toString() ? '' : product?._id?.toString())} size={20} /> : <FaChevronCircleUp style={{ minHeight: '25px', minWidth: '25px', cursor: 'pointer', color: '#333', }} onClick={() => setCurrentValue(state => state === product?._id?.toString() ? '' : product?._id?.toString())} size={20} />}

                            </td>
                        </tr>


                    })}

                    <tr><td colSpan={3}><aside style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}> <button style={{ minHeight: '48px' }} className="defaultButtonMini" onClick={() => addToGlobal(loadInfos)}>SALVAR</button></aside></td></tr>


                </tbody></table>
            </ProductContainerInfo> : <></>
        }

    </div >
}

export default ExtraProducts;